
const updateInterval = 3000 //3s
const defaultTimeOut = 300000 // 5min
const defaultMessage = "The device is restarting, please wait!"
let rebootCount = 0
let isNOReboot = false
let loadingInstance
let manageIP = ''

/**
 * 导航到登录页面
 * @param {*} vm 
 */
function logout(vm) {
    //关闭 loading
    loadingInstance.close()

    //清除 cookie
    cookie.clear()

    //导航到登录页
    if(manageIP === '')
        vm.$router.push('/')
    else
        window.location.href = `${manageIP}/`
}

/**
 * 循环获取重启状态
 */
function rebootLoop(vm) {
    if(isNOReboot || (updateInterval * rebootCount > defaultTimeOut))
    {
        logout(vm)
    }
    else
    {
        setTimeout(()=>{
            axios
            .post(`${manageIP}/boafrm/fhReboot`,{CmdType:"GET_REBOOT_STATUS"})
            .then((response)=>{
                if(response.data.ret === 0)
                {
                    isNOReboot = response.data.isNOReboot
                    logout(vm)
                }
            })
            .catch((error) => {
                rebootCount ++ 
                rebootLoop(vm)
            })
        },updateInterval);
    }
}

export default {
    /**
     * 先发重启请求，然后再显示 reboot loading
     */
    init(vm,message,ip){
        if(typeof ip !== 'undefined' && /^https?/i.test(ip)) 
            manageIP = ip
        else
            manageIP = ''
        axios
        .post(`${manageIP}/boafrm/fhReboot`)
        .then((response)=>{
            loadingInstance = vm.$loading({
                lock: true,
                text:message || defaultMessage
            });
            rebootLoop(vm);
        })
        .catch((error) => {
            isNOReboot = true
        })
    },
    /**
     * 直接显示reboot loading 不发重启请求
     */
    updata(vm,message,ip){
        if(typeof ip !== 'undefined' && /^https?/i.test(ip))
            manageIP = ip
        else
            manageIP = ''
        loadingInstance = vm.$loading({
            lock: true,
            text:message || defaultMessage
        });

        /**
         * 升级时 等待1min
         */
        setTimeout(()=>{
            rebootLoop(vm)
        },60000)
        
    }    
}
